import useSavedPlaces, { type SavedPlaceItem } from './useSavedPlaces'

type PrivateTourSaveInput = {
  id: string | number
  title: string
  duration: string
  price: string | number
  image: string
}

/**
 * Backward-compatible wrapper around useSavedPlaces for private-tour cards.
 */
export default function useSavedPrivateTours() {
  const { savedIds, isSaved, toggleSaved, removeSaved, upsertMany } = useSavedPlaces()

  const toggleSavedTour = (tour: PrivateTourSaveInput) => {
    const key = String(tour.id)
    const item: SavedPlaceItem = {
      id: key,
      source: 'private-tour',
      title: tour.title,
      duration: tour.duration,
      price: String(tour.price),
      image: tour.image,
      explorePath: `/private-tours?id=${key}`,
    }
    toggleSaved(item)
  }

  return {
    savedIds,
    isSaved,
    toggleSaved: toggleSavedTour,
    removeSaved,
    upsertMany,
  }
}
